export default __webpack_public_path__ + "static/media/network-rinkeby-logo.16c794f3.svg";